import { useQuery } from 'react-query';
import {
  fetchPretaxEligibleWallets,
  FetchPretaxEligibleWalletsResponse,
} from 'apis/pretaxAccount';
import { AxiosError } from 'axios';

export type IPretaxEligibleWallet =
  FetchPretaxEligibleWalletsResponse['eligibleAccounts'][0];

const getEligibleWallets = async ({
  formaEnrollment,
}: {
  formaEnrollment?: boolean;
}): Promise<{
  eligibleWallets: Array<IPretaxEligibleWallet>;
}> => {
  const {
    data: { eligibleAccounts },
  } = await fetchPretaxEligibleWallets({ formaEnrollment });
  return { eligibleWallets: eligibleAccounts };
};

const useQueryPretaxEligibleWallets = ({
  enabled,
  formaEnrollment,
  onError,
}: {
  enabled: boolean;
  onError?: (error: AxiosError) => void;
  formaEnrollment?: boolean;
}) => {
  const { data, isLoading, isError } = useQuery(
    ['getPretaxEligibleWallets'],
    () => getEligibleWallets({ formaEnrollment }),
    {
      onError,
      enabled,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useQueryPretaxEligibleWallets;
